import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DeviceDetectorService } from '@core/services/device-detector.service';
import { APP_SLUGS, MAIN_SLUGS } from '@routes/routes.types';

export const mobileGuard: CanActivateFn = () => {
    const router = inject(Router);
    const detector = inject(DeviceDetectorService);

    if (detector.isMobile()) {
        router.navigate([APP_SLUGS.mobile]);
        return false;
    } else {
        return true;
    }
};

export const desktopGuard: CanActivateFn = () => {
    const router = inject(Router);
    const detector = inject(DeviceDetectorService);

    if (!detector.isMobile()) {
        router.navigate([APP_SLUGS.MAIN]);
        return false;
    } else {
        return true;
    }
};
